import React from "react";
import { Outlet, useLoaderData, useLocation, useParams } from "react-router";

import RosterContent from "./components/RosterContent";
import { RosterProvider } from "./contexts/Roster";

import { IPlayer } from "../../../../types/api";

const Roster = (): React.JSX.Element => {
    const { roster } = useLoaderData() as {
        roster: IPlayer[];
    };

    const { teamId } = useParams();
    const location = useLocation();

    const isOnRosterPage = /team\/\d+\/roster\/?$/.test(location.pathname);

    return (
        <RosterProvider initialRoster={roster} teamId={teamId}>
            {isOnRosterPage ? <RosterContent /> : <Outlet />}
        </RosterProvider>
    );
};

export default Roster;
